import React from "react";

type KeyStatBlockProps = {
  label: string;
  value: string;
  children?: React.ReactNode;
};

export function KeyStatBlock({ label, value, children }: KeyStatBlockProps) {
  return (
    <div className="my-8 flex flex-col gap-1 border-t border-[var(--line)] pt-4 text-left">
      <span className="text-[10px] uppercase tracking-wider text-[var(--ink-soft)] font-mono font-semibold">
        {label}
      </span>
      <span className="text-2xl font-bold text-[var(--ink)] font-mono leading-none">
        {value}
      </span>
      {children && (
        <div className="text-sm text-[var(--ink-soft)] leading-relaxed mt-2 font-sans">
          {children}
        </div>
      )}
    </div>
  );
}
